import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f4a7f75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "search-container" }
const _hoisted_3 = { class: "p-input-icon-left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Actions", -1))

import { ref, onMounted, watch } from 'vue';
import { deleteCompany, fetchCompanyWhitelists, toggleStatus } from '@/_services/securite/whitelist/companyWhiteList';
import { CompanyWhitelist } from '@/models/securite/whitelist/IcompanyWhiteLis';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from 'primevue/useconfirm';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import InputSwitch from "primevue/inputswitch";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabByCompany',
  emits: ['update-table-data'],
  setup(__props, { emit }) {

const tableData = ref<CompanyWhitelist[]>([]);
const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const loading = ref<boolean>(true);
const page = ref<number>(1);
const criteria = ref<string>("");
const toast = useToast();
const confirm = useConfirm();

onMounted(async () => {
    await populateDatatable();
});

watch(tableData, (newData) => {
    emit('update-table-data', newData);
}, { deep: true });

async function populateDatatable() {
    loading.value = true
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchCompanyWhitelists(rows.value, page.value, criteria.value.trim());
    loading.value = loadingDt.value;
    tableData.value = tableDataDt.value;
    totalRecords.value = totalRecordsDt.value;
    
    return [loading.value, totalRecords.value, tableData.value]
}
const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    populateDatatable();
};
const onFilterDt = async () => {
    rows.value = 10;
    page.value = 1;
    populateDatatable();
};
const onClearInputFilter = () => {
    if (criteria.value.trim() === "") {
        rows.value = 10;
        page.value = 1;
        populateDatatable();
    }
};

const formatDate = (dateString) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
};
const handleStatusChange = async (data: CompanyWhitelist) => {
    try {
        await toggleStatus(data);
        toast.add({ severity: 'success', summary: 'Success', detail: 'Le statut a bien été modifié !', life: 3000 });
        await populateDatatable();
    } catch (error) {
        let errorMessage = 'Erreur inconnue.';
        if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
        } else if (error.message) {
            errorMessage = error.message;
        }
        toast.add({ severity: 'error', summary: 'Error', detail: errorMessage, life: 3000 });
    }
};
const confirmDeleteDialog = (company: CompanyWhitelist) => {
    confirm.require({
        group: 'global',
        message: 'Êtes-vous sûr de vouloir supprimer cette société ?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: "Oui",
        rejectLabel: "Non",
        acceptClass: 'p-button-danger',
        defaultFocus: "reject",
        accept: async () => {
            try {
                await deleteCompany(company.uuid);
                toast.add({ severity: 'success', summary: 'Supprimé', detail: 'La société a bien été supprimée', life: 3000 });
                await populateDatatable();
            } catch (error) {
                toast.add({ severity: 'error', summary: 'Erreur de suppression', detail: 'Échec de la suppression de la société', life: 3000 });
            }
        },
    });
};
/*const confirmStatusChangeDialog = (data) => {
    confirm.require({
        group: 'global-status',
        message: `Êtes-vous sûr de vouloir changer le statut de cet élément ?`,
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: "Oui",
        rejectLabel: "Non",
        accept: async () => {
            try {
                await toggleStatus(data);
                toast.add({ severity: 'success', summary: 'Succès', detail: `Le statut a bien été modifié`, life: 3000 });
                await populateDatatable();
            } catch (error) {
                let errorMessage = 'Erreur inconnue.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                } else if (error.message) {
                    errorMessage = error.message;
                }
                toast.add({ severity: 'error', summary: 'Erreur', detail: errorMessage, life: 3000 });
            }
        }
    });
};*/

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Tag = _resolveComponent("Tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(DataTable), {
        value: tableData.value,
        showGridlines: "",
        rows: rows.value,
        totalRecords: totalRecords.value,
        currentPage: currentPage.value,
        loading: loading.value,
        onPage: onPaginate,
        rowsPerPageOptions: [10, 25, 100],
        tableStyle: "min-width: 50rem",
        lazy: "",
        paginator: true
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _hoisted_4,
              _createVNode(_unref(InputText), {
                modelValue: criteria.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria).value = $event)),
                placeholder: "Rechercher par Société",
                onKeyup: _withKeys(onFilterDt, ["enter"]),
                onInput: onClearInputFilter
              }, null, 8, ["modelValue", "onKeyup"])
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucun résultat trouvé.")
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Column), {
            field: "company.name",
            header: "Société whitelistée"
          }),
          _createVNode(_unref(Column), {
            field: "description",
            header: "Description"
          }),
          _createVNode(_unref(Column), {
            field: "requestedBy",
            header: "Demandé par"
          }),
          _createVNode(_unref(Column), {
            field: "createdAt",
            header: "Date d'ajout"
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(formatDate(slotProps.data.createdAt)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), { header: "Ajouté par" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.createdBy.firstname) + " " + _toDisplayString(slotProps.data.createdBy.lastname), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "status",
            header: "Statut"
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Tag, {
                value: slotProps.data.status ? 'Actif' : 'Inactif',
                severity: slotProps.data.status ? 'success' : 'danger',
                rounded: ""
              }, null, 8, ["value", "severity"])
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), null, {
            header: _withCtx(() => [
              _hoisted_5
            ]),
            body: _withCtx((slotProps) => [
              _createVNode(_unref(InputSwitch), {
                modelValue: slotProps.data.status,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.status) = $event),
                onChange: () => handleStatusChange(slotProps.data)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
              _createVNode(_unref(Button), {
                onClick: () => confirmDeleteDialog(slotProps.data),
                type: "button",
                title: "Supprimer",
                icon: "pi pi-trash",
                class: "ml-1 p-button-danger"
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "rows", "totalRecords", "currentPage", "loading"])
    ])
  ], 64))
}
}

})